import React, { Component } from 'react';
import { connect } from 'react-redux'
import { createReview, linkReview } from '../../store/actions/restaurantActions'
import starIcon from '../../icons/star.svg';
import starIconFilled from '../../icons/star_filled.svg';
import { Editor } from '@tinymce/tinymce-react';
import ReviewSummary from './ReviewSummary'
import { backupReviewAdmin, deleteReviewAdmin, backupUserReviewAdmin, deleteUserReviewAdmin } from '../../store/actions/restaurantActions'
import { NavLink } from 'react-router-dom'

class Review extends Component {

  constructor(props) {
    super(props);
    this.state = {
    review:'',
    oneStar:false,
    twoStar:false,
    threeStar:false,
    fourStar:false,
    fiveStar:false,
    reviewScore:0,
    canReview:undefined,
    canReview2:undefined,
    canReview3:undefined,
    prevReview:undefined,
    revMessage:false,
    name:props.user.firstName + " " + props.user.lastName,
    userPoints:0
    }
  }

  componentDidMount(){
    if(this.props.points && this.props.auth && this.props.points[this.props.auth.uid]){
      var userPoints = 0;
      for(var point in this.props.points[this.props.auth.uid]){
        userPoints = userPoints + this.props.points[this.props.auth.uid][point];
      }
      if(this.state.userPoints !== userPoints){
        this.setState({userPoints:userPoints})
      }
    }
    if(this.props.restaurantReviews2){
      var revs = this.props.restaurantReviews2;
      if(revs!==undefined && revs!==null){
        var canReview = Object.entries(revs).some(rev=>{
        if(rev[1] !== null && rev[1].restaurantId === this.props.restaurantId
          && rev[1].userId === this.props.auth.uid ){
            this.setState({prevReview:rev});
            return true;
        }
        else {
          return false;
        }
        })       
      }
    this.setState({canReview:!canReview});
    }

    if(this.props.restaurantReviews2 && this.props.user && this.props.user.firstName === 'Guest'){
      var revs = this.props.restaurantReviews2;
      if(revs!==undefined && revs!==null){
        var canReview3 = Object.entries(revs).some(rev=>{
        if(rev[1] !== null && rev[1].userId === this.props.auth.uid ){
            return true;
        }
        else {
          return false;
        }
        })       
      }
    this.setState({canReview3:!canReview3});
    }

    if(this.props.pendingReviews || this.props.pendingReviews === null){
      var revs2 = this.props.pendingReviews;
      if(revs2!==undefined && revs2!==null){
        var canReview2 = Object.entries(revs2).some(rev=>{
        if(rev[1] !== null && rev[1].restaurantId === this.props.restaurantId
          && rev[1].userId === this.props.auth.uid ){
            this.setState({prevReview:rev});
            return true;
        }
        else {
          return false;
        }
        })       
      }
      else{canReview2 = false}
    this.setState({canReview2:!canReview2});
    }
  }

  componentDidUpdate(){
    if(this.state.name !== this.props.user.firstName + " " + this.props.user.lastName){
      console.log('name error');
      this.setState({
        name: this.props.user.firstName + " " + this.props.user.lastName
      })
    }

    if(this.state.reviewScore!==0){
      document.getElementById("zeroStars").style.display = "none";
    }
    else if(this.state.reviewScore===0){
      document.getElementById("zeroStars").style.display = "block";
    }

    if(this.props.restaurantReviews2 && this.state.canReview === undefined){
      var revs = this.props.restaurantReviews2;
      if(revs!==undefined && revs!==null){
        var canReview = Object.entries(revs).some(rev=>{
        if(rev[1] !== null && rev[1].restaurantId === this.props.restaurantId
          && rev[1].userId === this.props.auth.uid ){
            this.setState({prevReview:rev});
            return true;
        }
        else {
          return false;
        }
        })       
      }
    this.setState({canReview:!canReview});
    }

    if(this.props.restaurantReviews2 && this.state.canReview3 === undefined 
      && this.props.user && this.props.user.firstName === 'Guest'){
      var revs = this.props.restaurantReviews2;
      if(revs!==undefined && revs!==null){
        var canReview3 = Object.entries(revs).some(rev=>{
        if(rev[1] !== null && rev[1].userId === this.props.auth.uid ){
            return true;
        }
        else {
          return false;
        }
        })       
      }
    this.setState({canReview3:!canReview3});
    }
    
    if(this.state.canReview3 === undefined && this.props.user.firstName !== 'Guest'){
      if(!this.state.canReview3){
        this.setState({canReview3:true});
      }
    }

    if(this.props.pendingReviews && this.state.canReview2 === undefined){
      var revs2 = this.props.pendingReviews;
      if(revs2!==undefined && revs2!==null){
        var canReview2 = Object.entries(revs2).some(rev=>{
        if(rev[1] !== null && rev[1].restaurantId === this.props.restaurantId
          && rev[1].userId === this.props.auth.uid ){
            this.setState({prevReview:rev});
            return true;
        }
        else {
          return false;
        }
        })       
      }
      else{canReview2 = false}
    this.setState({canReview2:!canReview2});
    }

    if(!this.state.canReview2 && this.state.prevReview){
      for(var rev in this.props.reviewMessages){
        if(this.props.reviewMessages[rev] !== null && this.props.reviewMessages[rev]['project']['id'] === this.state.prevReview[0]){
          if(this.state.revMessage !== rev){
            this.setState({revMessage: rev})
          }
        }
      }
    }

    if(this.props.pendingReviews === null && this.state.canReview2 === undefined){
      this.setState({canReview2:true});
    }

  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    });  
  }

  deleteUserReviewInterruptor =(project)=>{
    this.setState({project:project});
    document.getElementById("deleteUserReviewModal").style.display = "block";
  }

  deleteReviewInterruptor =(project)=>{
    this.setState({project:project});
    document.getElementById("deleteReviewModal").style.display = "block";
  }

  handleDeleteUserReview = (e) => {
    e.preventDefault();
    this.props.backupUserReviewAdmin(this.state.project[1]);
    this.props.deleteUserReviewAdmin(this.state.project[1], this.state.project[0], ()=>{
      this.setState({review:'',canReview:undefined,
        canReview2:undefined,
        prevReview:undefined});
    });
    document.getElementById("deleteUserReviewModal").style.display = "none";
  }

  handleDeleteReview = (e) => {
    e.preventDefault();
    this.props.backupReviewAdmin(this.state.project);
    this.props.deleteReviewAdmin(this.state.project, this.state.prevReview[0], ()=>{
      this.setState({review:'',canReview:undefined,
        canReview2:undefined,
        prevReview:undefined});
    });
    document.getElementById("deleteReviewModal").style.display = "none";
  }

  handleEditorChange = (content, editor) => {
     this.setState({
      review:content
     })
   }

   handleInit = (e, editor) => {
    var resizeWidth=document.getElementById('starContainer').offsetWidth - 10;
    editor.dom.setStyle(editor.container, 'width', resizeWidth + 'px');
    }

  closeFunction =(e)=>{document.getElementById("messageConfirm").style.display = "none";}
  closeFunctionDeleteUserReview =(e)=>{document.getElementById("deleteUserReviewModal").style.display = "none";}
  closeFunctionDeleteReview =(e)=>{document.getElementById("deleteReviewModal").style.display = "none";}

  messageConfirmInterruptor =(e)=>{
  	e.preventDefault();
    // add in extra check for previous reviews here
    document.getElementById("messageConfirm").style.display = "block";
  }

  handleMessageConfirm = (e)=>{
  	e.preventDefault();
    this.props.createReview(this.state, this.props.restaurantId, ()=>{
      this.setState({canReview:undefined,
        canReview2:undefined,
        prevReview:undefined})
      });
    document.getElementById("messageConfirm").style.display = "none";   
  }

  starClick = (starNumber)=>{
    
    this.setState({
      oneStar:false,
      twoStar:false,
      threeStar:false,
      fourStar:false,
      fiveStar:false,
      reviewScore:0
    })

    switch(starNumber){
        case 1:
          this.setState({reviewScore:1, oneStar:true});
          break;
        case 2:
          this.setState({reviewScore:2, oneStar:true, twoStar:true});
          break;
        case 3:
          this.setState({reviewScore:3, oneStar:true, twoStar:true, threeStar:true});
          break;
        case 4:
          this.setState({reviewScore:4, oneStar:true, twoStar:true, threeStar:true, fourStar:true});
          break;
        case 5:
          this.setState({reviewScore:5, oneStar:true, twoStar:true, threeStar:true, fourStar:true, fiveStar:true});
          break;
        default:
          break;
        }
    
  }


  render() {
  	const { restaurantId, auth, user, restaurantReviews2, pendingReviews, points } = this.props;
    const oneStar = this.state.oneStar?starIconFilled:starIcon;
    const twoStar = this.state.twoStar?starIconFilled:starIcon;
    const threeStar = this.state.threeStar?starIconFilled:starIcon;
    const fourStar = this.state.fourStar?starIconFilled:starIcon;
    const fiveStar = this.state.fiveStar?starIconFilled:starIcon;

    var pendingLength = 0;

    if(pendingReviews === undefined || pendingReviews === null){
      pendingLength = 0;
    }
    else{
      pendingLength = Object.keys(pendingReviews).length;
    }

  	return (

  		<div className='messageContainer' style={{"width":"100%", "padding":"5px"}}>
        <div id="messageConfirm" className="modal2">
          <div className="modal-content2">
            <span className="close2" onClick={this.closeFunction}>&times;</span>
            <p>Are you sure you want to submit?</p>
            <div id="zeroStars" className="zeroStars">
              <h5>Warning - You are giving zero stars on this review.</h5>
              <p> click on the stars to rate the restaurant if you would like to award stars </p>
            </div>
            <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
              <button className="btn pink lighten-1" onClick={this.handleMessageConfirm}>Submit</button>
            </div>
          </div>
        </div>
      <div id="deleteUserReviewModal" className="modal2">
        <div className="modal-content2">
          <span className="close2" onClick={this.closeFunctionDeleteUserReview}>&times;</span>
          <p>Are you sure you want to delete your review?</p>
          <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
            <button className="btn pink lighten-1" onClick={this.handleDeleteUserReview}>Delete</button>
          </div>
        </div>
      </div>
      <div id="deleteReviewModal" className="modal2">
        <div className="modal-content2">
          <span className="close2" onClick={this.closeFunctionDeleteReview}>&times;</span>
          <p>Are you sure you want to delete your review?</p>
          <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
            <button className="btn pink lighten-1" onClick={this.handleDeleteReview}>Delete</button>
          </div>
        </div>
      </div> 
        {restaurantId && auth && restaurantReviews2 && (pendingReviews || pendingReviews === null) && (!this.state.canReview ||
          !this.state.canReview2) &&
      <div style={{textAlign:'center'}}>
      { this.state.canReview === false && this.state.prevReview !== undefined &&
        <div className="container-test">
          <p> You already have a review for this restaurant. </p>
          <ReviewSummary project={ this.state.prevReview[1].review } showOnStart={true} original={this.props.original} /> 
          <div className = 'adminButtons' style={{"display": "flex", "justifyContent": "center"}}>
            <button project={ this.state.prevReview } className="btn pink lighten-1" onClick={()=>{this.deleteUserReviewInterruptor(this.state.prevReview)}}>Delete</button>      
          </div>
        </div>
      }
      { this.state.canReview2 === false && this.state.prevReview !== undefined && !this.state.revMessage &&
        <div className="container-test">
          <p> You already have a pending review for this restaurant. </p>
          <ReviewSummary project={ this.state.prevReview[1] } showOnStart={true} original={this.props.original} /> 
          <div className = 'adminButtons' style={{"display": "flex", "justifyContent": "center"}}>
            <button project={ this.state.prevReview[1] } className="btn pink lighten-1" onClick={()=>{this.deleteReviewInterruptor(this.state.prevReview)}}>Delete</button>      
          </div>
        </div>
      }
      { this.state.canReview2 === false && this.state.prevReview !== undefined && this.state.revMessage &&
        <div className="container-test">
          <p> You already have a pending review for this restaurant.</p>
          <ReviewSummary userId={auth.uid} message={this.state.revMessage} project={ this.state.prevReview[1] } showOnStart={true} original={this.props.original} /> 
          <div className = 'adminButtons' style={{"display": "flex", "justifyContent": "center"}}>
            <button project={ this.state.prevReview[1] } className="btn pink lighten-1" onClick={()=>{this.deleteReviewInterruptor(this.state.prevReview)}}>Delete</button>      
          </div>
        </div>
      }
      </div>
        }
        {
        auth && pendingReviews && points && pendingLength > 9 && this.state.userPoints < 10 && this.state.canReview &&
          this.state.canReview2 && 
          <div style={{textAlign:"center"}}>
            <h3>You may not add reviews at this time.</h3>
            <p> Please wait until your current pending submissions are approved. </p>
            <p> Your limit on pending submissions will be raised when you are awarded points.</p>
            <p> You can delete pending submissions on your user page. </p>
            <NavLink to='/about/points' >About the point system</NavLink>
          </div> 
        }
        {
        
        auth && user && pendingReviews && points && pendingLength > 0 && this.state.userPoints < 10 && this.state.canReview &&
          this.state.canReview2 && user.firstName === "Guest" && 
          <div style={{textAlign:"center"}}>
            <h3>You may not add reviews at this time.</h3>
            <p> Guests are limited to one pending review.</p>
            <p> Please wait until your current pending submissions are approved. </p>
            <p> You can delete pending submissions on your user page. </p>
            <NavLink to='/about/points' >About the point system</NavLink>
          </div> 
        
        }
        {
        auth && user && (pendingReviews || pendingReviews === null ) && points && pendingLength < 1 && this.state.userPoints < 10 && this.state.canReview &&
          this.state.canReview2 && !this.state.canReview3 && user.firstName === "Guest" && 
          <div style={{textAlign:"center"}}>
            <h3>You may not add reviews at this time.</h3>
            <p> Guests are limited to one review.</p>
            <NavLink to='/about/points' >About the point system</NavLink>
          </div> 
        }
  			{restaurantId && auth && user && restaurantReviews2 && (pendingReviews || pendingReviews === null) && this.state.canReview &&
          this.state.canReview2 && this.state.canReview3 && (pendingLength < 10 || this.state.userPoints > 9 ) && (user.firstName !== "Guest" || pendingLength < 1) &&
      <div className='outerReviewContainer'> 
  		<div className='reviewContainer' id="starContainer">
        <div style={{"width":"100%"}}  onClick={() => this.starClick(0)}/>
        <div className='reviewContainer'>
        <div><img src={oneStar} onClick={() => this.starClick(1)} className="favIcon" alt="star" width="20px" height="20px" viewBox="0 0 20 20"/></div>  
        <div><img src={twoStar} onClick={() => this.starClick(2)} className="favIcon" alt="star" width="20px" height="20px" viewBox="0 0 20 20"/></div>  
        <div><img src={threeStar} onClick={() => this.starClick(3)} className="favIcon" alt="star" width="20px" height="20px" viewBox="0 0 20 20"/></div>  
        <div><img src={fourStar} onClick={() => this.starClick(4)} className="favIcon" alt="star" width="20px" height="20px" viewBox="0 0 20 20"/></div>  
        <div><img src={fiveStar} onClick={() => this.starClick(5)} className="favIcon" alt="star" width="20px" height="20px" viewBox="0 0 20 20"/></div>  
  	 	  </div>
        <div style={{"width":"100%"}}  onClick={() => this.starClick(0)}/>
      </div>
      <div className='reviewContainer'>  
        
  			<div className="input-field2" id="editorParent">
            <Editor
             apiKey = "j1avn6800qx0kl1a8g28hwd9j85dwvja7qg8r7o62tl4vxaf"
             id = 'tinyMce'
             initialValue=""
             onInit={this.handleInit}
             init={{
               height: 300,
               // width: 500,
               menubar: false,
               plugins: [
                  'autoresize',
                 'advlist autolink lists link image charmap print preview anchor',
                 'searchreplace visualblocks code fullscreen',
                 'insertdatetime media table paste code help wordcount'
               ],
               toolbar:
                 'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help'
             }}
             onEditorChange={this.handleEditorChange}
            />
          <div style={{"display": "flex", "justifyContent": "center", "paddingTop":"5px"}}>  
            <button className="btn pink lighten-1" onClick={this.messageConfirmInterruptor}>Submit</button>
          </div>
        </div>
  
        </div>
        </div>
      		}
  		</div>
  	)
  }


}

const mapStateToProps = (state) => {
  const user = state.firestore.data.users
                && state.firestore.data.users[state.firebase.auth.uid]
  return {
    auth: state.firebase.auth,
    restaurantReviews2: state.firestore.data.restaurantReviews2,
    pendingReviews: state.firestore.data.pendingReviews,
    reviewMessages: state.firestore.data.reviewMessages,
    points: state.firestore.data.points,
    user
  }
}

const mapDispatchToProps = dispatch => {
  return {
    createReview: (message, restaurantId, callback) => dispatch(createReview(message, restaurantId, callback)),
    linkReview: (message, restaurantId) => dispatch(linkReview(message,restaurantId)),
    deleteUserReviewAdmin: (project, reviewId, callback) => dispatch(deleteUserReviewAdmin(project, reviewId, callback)),
    backupUserReviewAdmin: (project) => dispatch(backupUserReviewAdmin(project)),
    deleteReviewAdmin: (project, reviewId, callback) => dispatch(deleteReviewAdmin(project, reviewId, callback)),
    backupReviewAdmin: (project) => dispatch(backupReviewAdmin(project))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Review)